function b64EncodeUnicode (str) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode('0x' + p1)
    })
  )
}

function b64DecodeUnicode (str) {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
}

export default {
  b64EncodeUnicode,
  b64DecodeUnicode
}



// WEBPACK FOOTER //
// ./src/utils/base64.js